export function addField(fieldName: string) {
  return `&fields[]=${fieldName}`;
}

function addFieldsQuery(fields: string[]) {
  return fields.map(addField).join('');
}

export default addFieldsQuery;
